import InvestBlock from './InvestBlock';

export default InvestBlock;
